if (!customElements.get('hoculus-buy-now')) {
    class hoculusBuyNow extends HTMLElement {
        constructor() {
            super();
            this.form = this.querySelector('form');
        }

        connectedCallback() {
            this.form.addEventListener('ajaxProduct:added', function() {
                document.location.href = '/cart/checkout'
            });

            this.form.addEventListener('cart:updated', function() {
                document.location.href = '/cart/checkout'
            });
        }
    }
    customElements.define("hoculus-buy-now", hoculusBuyNow);
}